<template>
  <div class="page event-management">
    <management-nav @save="saveTicketsToEvent"></management-nav>
    <side-menu activeNav="Event" childName="Pages"></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading title="Edit Pages"></heading>

        <div>
          <form action="">
            <div>
              <div class="aboutUs_input textarea_container">
                <div>
                  <label for="aboutUs">About Us</label>
                </div>
                <textarea name="aboutUs" id="" cols="7" rows="5" v-model="aboutUs"></textarea>
                <button @click="editTextArea" class="btn">Edit</button>
              </div>
              <div class="press_input textarea_container">
                <div>
                  <label for="press">Press</label>
                </div>
                <textarea name="press" id="" cols="7" rows="5" v-model="press"></textarea>
                <button @click="editTextArea" class="btn">Edit</button>
              </div>
              <div class="faq_input textarea_container">
                <div>
                  <label for="faq">FAQ</label>
                </div>
                <textarea name="faq" id="" cols="7" rows="5" v-model="faq"></textarea>
                <button @click="editTextArea" class="btn">Edit</button>
              </div>
              <div class="news_input textarea_container">
                <div>
                  <label for="news">News</label>
                </div>
                <textarea name="news" id="" cols="7" rows="5" v-model="news"></textarea>
                <button @click="editTextArea" class="btn">Edit</button>
              </div>
              <div class="gettingThere_input textarea_container">
                <div>
                  <label for="gettingThere">Getting There</label>
                </div>
                <textarea name="gettingThere" id="" cols="7" rows="5" v-model="gettingThere"></textarea>
                <button @click="editTextArea" class="btn">Edit</button>
              </div>
              <div class="contactUs_input textarea_container">
                <div>
                  <label for="contactUs">Contact Us</label>
                </div>
                <textarea name="contactUs" id="" cols="7" rows="5" v-model="contactUs"></textarea>
                <button @click="editTextArea" class="btn">Edit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;

export default {
  name: "pages",
  components: {
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
  },
  data() {
    return {
      aboutUs: "",
      press: "",
      faq: "",
      news: "",
      gettingThere: "",
      contactus: "",
    };
  },
  created() {},
  methods: {
      editTextArea() {
          console.log('editing')
      }
  },
};
</script>

<style lang="scss"></style>